import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/admin-dashboard/components/DashboardInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/AdminSidebar.tsx");
